// Team Correspondence (team detail > Correspondence): per team member, each client contact's roles.
// A member x contact with no stored cell has every role off.
// The four toggle pills, in order; each "on" pill is filled in its colour, "off" pills are grey
export const TEAM_CORRESPONDENCE_ROLES = [
    { key: "isConnectedContact", label: "Associated contact", colour: "blue" },
    { key: "isPerformanceApprover", label: "Appraisal reviewer", colour: "purple" },
    { key: "isPrimaryLeaveApprover", label: "Primary leave approver", colour: "green" },
    { key: "isSecondaryLeaveApprover", label: "Secondary leave approver", colour: "amber" },
];
export function teamCorrespondenceHasAnyRole(cell) {
    return cell.isConnectedContact || cell.isPerformanceApprover || cell.isPrimaryLeaveApprover || cell.isSecondaryLeaveApprover;
}
